module.exports = __webpack_public_path__ + "static/media/Group468.342d685c.png";